import PropTypes from 'prop-types';

export const defaultProps = {
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  handleToast: PropTypes.func,
};
export const propTypes = {
  loading: false,
  setLoading: () => {},
  handleToast: () => {},
};
